import { Modification } from '@vality/swag-claim-management';

import ModificationTypeEnum = Modification.ModificationTypeEnum;

export const PARTY_MODIFICATION: Modification = {
    modificationType: ModificationTypeEnum.PartyModification,
};
